type Logger = (fmt: string, ...args: any[]) => void;

export let logWhenInDevMode: Logger = () => {};
export let warnWhenInDevMode: Logger = () => {};

function getCallLocation(): string {
  const { stack } = new Error();

  if (!stack) {
    return '';
  }

  const frames = stack.split('\n');

  if (frames[0] === 'Error') {
    frames.shift();
  }

  const stackOffset = 2; // getCallLocation <- logger <- call site
  const caller = frames[stackOffset]?.trim() ?? '';

  if (caller.startsWith('at ')) {
    return caller.substring('at '.length);
  }

  return caller;
}

function makeLogger<F extends (...args: any[]) => void>(print: F): Logger {
  return (fmt, ...args) => {
    const caller = getCallLocation();

    print(
      `%c[UI]%c %c${caller}%c\n${fmt}`,
      'font-weight: bold',
      'font-weight: normal',
      'color: CornflowerBlue',
      'color: unset',
      ...args
    );
  };
}

if (process.env.REACT_APP_ENV !== 'production') {
  logWhenInDevMode = makeLogger(console.log);
  warnWhenInDevMode = makeLogger(console.warn);
}
